import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import ThemeProvider from './Components/Context/Context';
ReactDOM.render(<ThemeProvider>
<App /></ThemeProvider>, document.getElementById('root'));

registerServiceWorker();
